import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSparkleFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, h, p, a) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--sparkle-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Sparkle Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.544 11a.443.443 0 0 0 .443-.443v-.57h.57a.443.443 0 1 0 0-.886h-.57v-.57a.443.443 0 1 0-.886 0v.57h-.57a.443.443 0 1 0 0 .886h.57v.57c0 .245.198.443.443.443ZM4.988 9.987a.443.443 0 0 0 .403-.26L6.43 7.443l2.285-1.039a.443.443 0 0 0 0-.806L6.43 4.557 5.39 2.273a.443.443 0 0 0-.806 0L3.545 4.558 1.26 5.597a.443.443 0 0 0 0 .806l2.285 1.04 1.039 2.285c.072.158.23.26.403.26l.001-.001Zm4.077-6.076a.443.443 0 0 0 .443-.443v-.57h.57a.443.443 0 0 0 0-.885h-.57v-.57a.443.443 0 0 0-.886 0v.57h-.57a.443.443 0 1 0 0 .886h.57v.57c0 .244.199.442.443.442Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const S = /* @__PURE__ */ s(c, [["render", u]]);
export {
  S as default
};
//# sourceMappingURL=sparkle-filled.js.map
